// Hindi of src/content/legal/terms.ts. Keep keys and structure in step with the English.
import { COMPANY, GRIEVANCE_OFFICER } from '../company';
import type { LegalDoc } from './types';

export const TERMS_HI: LegalDoc = {
  title: 'उपयोग की शर्तें',
  summary:
    'Nurture आपको अपने बच्चे के रोज़मर्रा के विकास को समझने और घर पर मदद की योजना बनाने में मदद करता है। यह निदान नहीं है। ये शर्तें बताती हैं कि आप हमसे क्या उम्मीद कर सकते हैं और हम आपसे क्या चाहते हैं।',
  updated: '28 September 2026',
  sections: [
    {
      id: 'acceptance',
      heading: 'स्वीकृति',
      blocks: [
        'यह हिंदी अनुवाद आपकी सुविधा के लिए है। किसी भी अंतर की स्थिति में अंग्रेज़ी संस्करण मान्य होगा।',
        `ये शर्तें आपके और **${COMPANY.legalName}** (“ZenQuip”, “हम”) के बीच एक समझौता हैं। अकाउंट बनाकर या Nurture का इस्तेमाल करके आप इन शर्तों और हमारी [निजता नीति](/privacy) को स्वीकार करते हैं। अगर आप सहमत नहीं हैं, तो कृपया Nurture का इस्तेमाल न करें।`,
      ],
    },
    {
      id: 'eligibility',
      heading: 'Nurture का इस्तेमाल कौन कर सकता है',
      blocks: [
        'आपकी उम्र 18 साल या उससे ज़्यादा होनी चाहिए, और आप जिस भी बच्चे की जानकारी दर्ज करते हैं, आपको उसके माता-पिता या क़ानूनी अभिभावक होना चाहिए। आपके बुलाए गए परिवार के सदस्य रिपोर्ट देख सकते हैं; वे बच्चे नहीं जोड़ सकते और न ही कुछ बदल सकते हैं।',
        'Nurture 18 महीने से 18 साल तक के बच्चों के लिए तैयार किया गया है।',
      ],
    },
    {
      id: 'service',
      heading: 'Nurture क्या है',
      blocks: [
        'आप अपने बच्चे के रोज़मर्रा के व्यवहार के बारे में सवालों के जवाब देते हैं। Nurture एक रिपोर्ट तैयार करता है जो आसान शब्दों में बताती है कि हर क्षेत्र की स्थिति कैसी है, “पड़ाव पूरे हो रहे हैं”, “नज़र रखते रहें” या “ध्यान देने की ज़रूरत” साथ में आपके बच्चे के डॉक्टर या थेरेपिस्ट के लिए एक पेज और, पेड प्लान के साथ, गतिविधियों का एक घरेलू प्रोग्राम।',
        'सवाल और कंटेंट क्लिनिशियन के साथ मिलकर, विकास के स्थापित फ़्रेमवर्क के आधार पर बनाए गए हैं। रिपोर्ट सिर्फ़ वही दिखाती है जो आपने हमें बताया, उसी दिन जिस दिन आपने बताया।',
      ],
    },
    {
      id: 'medical-disclaimer',
      heading: 'चिकित्सा संबंधी अस्वीकरण',
      blocks: [
        '**ZenQuip एक मानसिक स्वास्थ्य सहायता प्लेटफ़ॉर्म है। यह चिकित्सीय निदान नहीं देता और किसी योग्य प्रोफ़ेशनल द्वारा जाँच या इलाज का विकल्प नहीं है। अगर आप संकट में हैं, तो तुरंत Tele-MANAS 14416 (या 1-800-891-4416) या KIRAN 1800-599-0019 या Vandrevala Foundation +91 9999 666 555 (भारत) पर कॉल करें, या अपनी स्थानीय आपातकालीन सेवाओं से संपर्क करें।**',
        'Nurture की रिपोर्ट न तो निदान है, न स्क्रीनिंग का नतीजा, न क्लिनिकल आकलन, और यह किसी योग्य प्रोफ़ेशनल की सलाह की जगह नहीं लेती। रिपोर्ट में लिखी किसी भी बात की वजह से प्रोफ़ेशनल देखभाल में देरी न करें और न ही उसे रोकें। घर की गतिविधियाँ सामान्य सुझाव हैं; जिस गतिविधि से आपका बच्चा परेशान हो, उसे रोक दें और किसी प्रोफ़ेशनल से पूछें।',
        'Nurture कोई आपातकालीन सेवा नहीं है और इसकी रियल टाइम में निगरानी नहीं की जाती।',
      ],
    },
    {
      id: 'how-results-are-made',
      heading: 'नतीजे कैसे तैयार होते हैं',
      blocks: [
        'नतीजे तय नियमों और क्लिनिशियन के लिखे कंटेंट से आते हैं: एक जैसे जवाबों से एक जैसा नतीजा मिलता है। आपके बच्चे के नतीजे कोई AI मॉडल नहीं लिखता। सटीकता आपके जवाबों पर निर्भर करती है, इसलिए अपने बच्चे के सामान्य व्यवहार के आधार पर जवाब दें।',
        'अगर आप किसी पहले हुए प्रोफ़ेशनल आकलन के नतीजे दर्ज करते हैं, तो हम उनका इस्तेमाल वैसे ही करते हैं जैसे आप उन्हें दर्ज करते हैं; कृपया उन्हें ठीक वैसे ही दर्ज करें जैसे वे उस रिपोर्ट में लिखे हैं।',
      ],
    },
    {
      id: 'your-responsibilities',
      heading: 'आपकी ज़िम्मेदारियाँ',
      blocks: [
        [
          'सही जानकारी दें और उसे अपडेट रखें;',
          'अपना साइन-इन निजी रखें, और अगर आपको लगे कि किसी और ने आपका अकाउंट इस्तेमाल किया है तो हमें बताएँ;',
          'दूसरे लोगों का विवरण (केयर टीम, परिवार, नॉमिनी) सिर्फ़ ठोस वजह से और ऐसे तरीक़े से जोड़ें जिसकी उन्हें उम्मीद हो;',
          'रिपोर्ट और लिंक सिर्फ़ उन्हीं लोगों के साथ साझा करें जिन पर आप अपने बच्चे की जानकारी के मामले में भरोसा करते हैं।',
        ],
      ],
    },
    {
      id: 'payments',
      heading: 'भुगतान और प्लान',
      blocks: [
        'घरेलू आकलन और हर रिपोर्ट के शुरुआती पेज मुफ़्त हैं। किसी पेड अनलॉक या Nurture Plus में क्या शामिल है, और उसकी कीमत (GST अलग से दिखाकर या शामिल करके), भुगतान से पहले दिखाई जाती है। Nurture Plus हर तिमाही अपने-आप रिन्यू होता है, जब तक आप इसे सेटिंग्स में रद्द नहीं करते; रद्द करने से अगला चार्ज रुक जाता है और तिमाही के अंत तक आपके पास वह सब रहता है जिसका आपने भुगतान किया है।',
        'भुगतान हमारे पेमेंट प्रोवाइडर द्वारा प्रोसेस किए जाते हैं। हम भविष्य की ख़रीदारी के लिए कीमतें बदल सकते हैं; जिस रिपोर्ट का आपने भुगतान कर दिया है, वह जैसी तैयार हुई थी वैसी ही उपलब्ध रहती है।',
      ],
    },
    {
      id: 'refunds',
      heading: 'रिफ़ंड',
      blocks: ['हमारी [रिफ़ंड नीति](/refunds) देखें।'],
    },
    {
      id: 'intellectual-property',
      heading: 'बौद्धिक संपदा',
      blocks: [
        'Nurture के सवाल, कंटेंट, डिज़ाइन और सॉफ़्टवेयर ZenQuip या उसके लाइसेंसदाताओं के हैं। आपकी रिपोर्ट आपकी है, अपने बच्चे की देखभाल के लिए आप इसे रख सकते हैं, प्रिंट कर सकते हैं और साझा कर सकते हैं। कृपया Nurture के कंटेंट को कॉपी न करें, दोबारा न बेचें या प्रकाशित न करें, और न ही इसका इस्तेमाल कोई प्रतिस्पर्धी प्रोडक्ट बनाने के लिए करें।',
      ],
    },
    {
      id: 'prohibited-use',
      heading: 'आपको क्या नहीं करना चाहिए',
      blocks: [
        [
          'ऐसे किसी बच्चे की जानकारी दर्ज करना जिसके आप माता-पिता या क़ानूनी अभिभावक नहीं हैं;',
          'किसी योग्य प्रोफ़ेशनल के बिना, किसी बच्चे का निदान करने, उस पर कोई लेबल लगाने या उसके बारे में फ़ैसले लेने के लिए Nurture का इस्तेमाल करना;',
          'दूसरे लोगों के अकाउंट, रिपोर्ट या लिंक तक पहुँचने की कोशिश करना, या सेवा में बाधा डालना;',
          'Nurture को स्क्रैप, कॉपी या रिवर्स-इंजीनियर करना।',
        ],
      ],
    },
    {
      id: 'suspension',
      heading: 'निलंबन',
      blocks: [
        'जो अकाउंट इन शर्तों का उल्लंघन करता है या दूसरों को जोखिम में डालता है, उसे हम निलंबित या बंद कर सकते हैं। जहाँ संभव हो, हम पहले आपको बताएँगे और आपको अपना डेटा डाउनलोड करने देंगे।',
      ],
    },
    {
      id: 'liability',
      heading: 'दायित्व की सीमा',
      blocks: [
        'Nurture पूरी सावधानी से, लेकिन “जैसा है” (“as is”) के आधार पर दिया जाता है। क़ानून जिस हद तक अनुमति देता है, उस हद तक ZenQuip किसी रिपोर्ट के आधार पर लिए गए फ़ैसलों के लिए, या अप्रत्यक्ष या परिणामी नुक़सान के लिए ज़िम्मेदार नहीं है। किसी भी दावे के लिए आपके प्रति हमारा कुल दायित्व उस राशि तक सीमित है जो आपने उस दावे से पहले के 12 महीनों में हमें चुकाई है। यहाँ लिखी कोई भी बात ऐसे दायित्व को सीमित नहीं करती जिसे क़ानून के तहत सीमित नहीं किया जा सकता।',
      ],
    },
    {
      id: 'indemnity',
      heading: 'क्षतिपूर्ति',
      blocks: [
        'अगर Nurture का इस्तेमाल करते समय आप इन शर्तों या क़ानून का उल्लंघन करते हैं, और इस वजह से ZenQuip के ख़िलाफ़ कोई दावा किया जाता है, तो आप उस दावे का उचित ख़र्च उठाने के लिए सहमत हैं।',
      ],
    },
    {
      id: 'privacy',
      heading: 'निजता',
      blocks: ['हम व्यक्तिगत डेटा को कैसे संभालते हैं, यह हमारी [निजता नीति](/privacy) और हमारे [Trust पेज](/trust) पर बताया गया है।'],
    },
    {
      id: 'governing-law',
      heading: 'लागू क़ानून',
      blocks: [
        'ये शर्तें भारत के क़ानूनों के अधीन हैं। लागू क़ानून के अधीन रहते हुए, इनसे पैदा होने वाले विवादों पर **जयपुर, राजस्थान** की अदालतों का विशेष (exclusive) अधिकार क्षेत्र होगा।',
      ],
    },
    {
      id: 'changes',
      heading: 'इन शर्तों में बदलाव',
      blocks: [
        'हम इन शर्तों को अपडेट कर सकते हैं। हम बदलाव यहाँ पोस्ट करेंगे और ऊपर दी गई तारीख़ बदल देंगे; अगर कोई बदलाव आपके लिए मायने रखता है, तो उसके लागू होने से पहले हम आपको बताएँगे। उसके बाद Nurture का इस्तेमाल करने का मतलब है कि आप नई शर्तें स्वीकार करते हैं।',
      ],
    },
    {
      id: 'contact',
      heading: 'संपर्क',
      blocks: [
        `सवाल: [${COMPANY.supportEmail}](mailto:${COMPANY.supportEmail})। शिकायतें: हमारे शिकायत अधिकारी, ${GRIEVANCE_OFFICER.name}, [${GRIEVANCE_OFFICER.email}](mailto:${GRIEVANCE_OFFICER.email}), ${GRIEVANCE_OFFICER.phone}।`,
      ],
    },
  ],
};
